<template>
  <div class="ioRecord">
    <div class="right">
      
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <el-input v-model="search.categoryName"></el-input>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
               :disabled="loading">
              <i v-if="loading" class="el-icon-loading"></i>
              {{ loading ? "查询中..." : "查询" }}
            </button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="add"
                @click="addDialog()"
              >
                添加
              </button>
            </span>
          </div>
        </form>
      </div>
      <template>
        <div v-show="showList" class="list-right">
          <el-table v-loading="loading" element-loading-text="加载中..."
            ref="table"
            border
            :data="tableListData"
            height="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
          >
            <el-table-column
              show-overflow-tooltip
              label="分类名称"
              prop="name"
            ></el-table-column>
            

            <el-table-column
              show-overflow-tooltip
              label="图片"
              prop="icon"
            >
              <span slot-scope="scope">
                <button
                :style="{margin:'5px',padding:'0 10px','box-sizing': 'border-box',cursor:!scope.row.icon?'not-allowed':'pointer'}"
                  type="primary;"
                  @click="onImgPreviewClick(scope.row)"
                  :disabled="!scope.row.icon"
                >
              预览图片
              </button>
              </span>
            </el-table-column>
            
            <el-table-column
              show-overflow-tooltip
              label="添加时间"
              prop="crtTime"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="备注"
              prop="description"
            ></el-table-column>
                <el-table-column
              show-overflow-tooltip
              label="排序"
              width="120"
            >
              <template slot-scope="scope">
                <div class="sort-edit-container">
                  <span v-if="!scope.row.editingSort" class="sort-display">
                    {{ scope.row.sort }}
                    <i 
                      class="el-icon-edit sort-edit-icon" 
                      @click="startSortEdit(scope.row)"
                      title="点击编辑排序"
                    ></i>
                  </span>
                  <div v-else class="sort-edit-input">
                    <el-input-number
                      v-model="scope.row.tempSort"
                      :min="0"
                      :max="9999"
                      size="mini"
                      style="width: 80px;"
                    ></el-input-number>
                    <i 
                      class="el-icon-check sort-confirm-icon" 
                      @click="confirmSortEdit(scope.row)"
                    ></i>
                    <i 
                      class="el-icon-close sort-cancel-icon" 
                      @click="cancelSortEdit(scope.row)"
                    ></i>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="250px">
              <template slot-scope="scope">
                <button
                  type="button"
                  class="edit"
                  @click="editDialog(scope.row)"
                >
                  修改
                </button>
                <button class="delete" @click="del(scope.row.id)">删除</button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </div>
    <Page v-show="showList" v-on:pagination="receivePaginationData"></Page>
    <merchant-class-add
      v-if="showAddDialog"
      v-on:closeDialog="closeDialog"
    ></merchant-class-add>
    <merchant-class-edit
      :detail="currentRow"
      v-if="showEditDialog"
      v-on:closeDialog="closeDialog"
    ></merchant-class-edit>
    <el-image-viewer
      v-if="imgViewerVisible"
      :on-close="closeImgViewer"
      :url-list="[currentImgRow.icon]"
    >
    </el-image-viewer>
  </div>
</template>
  
  <script>
import { mapState, mapMutations } from "vuex";
import { shopMerchantCategoryList, shopMerchantCategoryEdit } from "@/api/url";
import Page from "@/page/commons/page";
import dayjs from "dayjs";
import MerchantClassAdd from "./merchant-class-add.vue";
import MerchantClassEdit from "./merchant-class-edit.vue";
import elImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  name: "promotional-discounts",
  components: {
    Page,
    MerchantClassAdd,
    MerchantClassEdit,
    elImageViewer
  },
  data() {
    return {
      loading: false,
      moduleName: "property",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      groupList: [],
      tableListData: [
        // {
        //   merchantName: "test",
        //   contacts: "test",
        //   telephone: "test",
        //   picture:
        //     "https://roadside-parking.oss-cn-shenzhen.aliyuncs.com/share_parking/2b8247df91314d64b24b65d603d49063.jpg",
        //   url: "www.baidu.com",
        //   updateTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        //   remark: "test",
        // },
      ],
      tableListDataTitle: [],
      switchValue: "list",
      showList: true,
      showChart: false,
      search: {
        pageSize: 10,
        pageNumber: 1,
        categoryName: "",
      },
      value4: "",
      currentRow: {},
      showAddDialog: false,
      showEditDialog: false,
      currentImgRow: {},
      imgViewerVisible: false,
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList: function (curPage) {
      this.loading = true;
      var _this = this;
      this.$get(shopMerchantCategoryList(), {
        page: curPage,
        limit: this.search.pageSize,
        categoryName: this.search.categoryName,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      }).finally(() => {
        this.loading = false;
      });
},

    searchList: function () {
      if (this.loading) return;
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    closeDialog(type) {
      this.showAddDialog = false;
      this.showEditDialog = false;
      if (type == "add") {
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      }
      if (type == "edit") {
        this.tableList(this.curIndex);
      }
    },
    addDialog() {
      this.showAddDialog = true;
    },
    editDialog(row) {
      this.showEditDialog = true;
      this.currentRow = { ...row };
    },
    del(id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          _this
            .$deleteRequest(shopMerchantCategoryEdit() + "/" + id)
            .then((data) => {
              // if (data.status != 200)
              //   return _this.$layer.msg("删除失败", { time: 1 });
              // _this.$notify({
              //   type: "success",
              //   title: "成功",
              //   message: "删除成功!",
              // });
                _this.$notify({
                type: "none",
                // title: "成功",
                message: data?.data??"删除失败!",
              });
        
              _this.tableList(_this.curIndex);
            });
        }
      );
    },
    onImgPreviewClick(row) {
      this.imgViewerVisible = true;
      this.currentImgRow = { ...row };
      console.log(row);
    },
    closeImgViewer() {
      this.imgViewerVisible = false;
    },
    
    // 开始排序编辑
    startSortEdit(row) {
      console.log("开始编辑排序:", row);
      this.$set(row, 'editingSort', true);
      this.$set(row, 'tempSort', row.sort);
    },

    // 确认排序编辑
    async confirmSortEdit(row) {
      try {
        if (row.tempSort === row.sort) {
          // 没有变化，直接取消编辑
          this.$set(row, 'editingSort', false);
          return;
        }

        const params = {
          id: row.id,
          sort: row.tempSort
        };
        
        // 调用API更新排序
        const res = await this.$putRequest(shopMerchantCategoryEdit() + "/" + row.id, params);
        
        if (res.status === 200) {
          this.$set(row, 'sort', row.tempSort);
          this.$set(row, 'editingSort', false);
          this.$message.success("排序更新成功");
          // 刷新列表
          this.tableList(this.curIndex);
        } else {
          throw new Error(res.message || "排序更新失败");
        }
      } catch (error) {
        console.error("排序更新失败:", error);
        // 恢复原值
        this.$set(row, 'tempSort', row.sort);
        this.$set(row, 'editingSort', false);
      }
    },

    // 取消排序编辑
    cancelSortEdit(row) {
      this.$set(row, 'tempSort', row.sort);
      this.$set(row, 'editingSort', false);
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      nodeData: (state) => state.nodeData,
      nod: (state) => state.nod,
    }),
  },
  mounted() {
    this.search.pageNumber=1
    this.tableList(1);
  },
};
</script>
  
  <style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
  width: 16px;
}
.switch-info {
  display: inline-block;
  margin-left: 5px;
  width: 16px;
}
.show-list {
  height: 500px;
}
</style>
  <style>

.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
.download_btn {
  display: inline-block;
  margin-left: 15px;
}

/* 排序编辑样式 */
.sort-edit-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sort-display {
  display: flex;
  align-items: center;
  gap: 5px;
}

.sort-edit-icon {
  cursor: pointer;
  color: #409eff;
  font-size: 14px;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.sort-edit-icon:hover {
  opacity: 1;
}

.sort-edit-input {
  display: flex;
  align-items: center;
  gap: 5px;
}

.sort-confirm-icon {
  cursor: pointer;
  color: #67c23a;
  font-size: 14px;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.sort-confirm-icon:hover {
  opacity: 1;
}

.sort-cancel-icon {
  cursor: pointer;
  color: #f56c6c;
  font-size: 14px;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.sort-cancel-icon:hover {
  opacity: 1;
}
</style>
  